import React from "react";
import { Form, Input, type FormInstance } from "antd";

type SearchBarProps = {
	placeholder: string;
	onFilter: () => void;
  form: FormInstance;
	searchName?: string;
};

export function SearchBar({
	placeholder,
	onFilter,
  form,
	searchName = "search",
}: SearchBarProps) {
	return (
		<Form form={form} style={{flex: "1 1 auto"}}>
			<Form.Item noStyle name={searchName}>
				<Input.Search
					placeholder={placeholder}
					onSearch={onFilter}
					allowClear
				/>
			</Form.Item>
		</Form>
	);
}
